import {
  AccountStatus,
  GetCategoriesResponse,
  GetSupportPlanResponse,
  GetUserAuthenticated,
  SupportApiResponse,
  SystemStatusResponse,
} from "../types";

export const mockGetCsrfResponse = {
  csrf: "0000000000000000000000000000000000000000000000000000000000000000",
};

export const mockAuthenticatedUserResponse: SupportApiResponse<GetUserAuthenticated> =
  {
    status: 200,
    statusCode: 200,
    success: true,
    data: {
      account: {
        active: 1,
        currentAccountSid: "AC000000000000000000000000000000",
        dateCreated: "",
        dateUpdated: "",
        emailAddr: "JohnDoe@gmail.com",
        emailValidated: true,
        firstName: "John",
        flags: [],
        friendlyName: "",
        isoCountryCode: "us",
        lastName: "Doe",
        preferredLanguage: "us_english",
        sid: "AC000000000000000000000000000000",
        status: AccountStatus.active,
        upgraded: true,
        userType: 1,
        version: 1,
      },
      user: {
        sid: "US00000000000000000000000000000000",
        emailAddr: "JohnDoe@gmail.com",
        firstName: "John",
        lastName: "Doe",
        friendlyName: "",
        dateCreated: "",
        dateUpdated: "",
        active: 1,
        isoCountryCode: "",
        userType: 1,
        currentAccountSid: "US00000000000000000000000000000000",
        emailValidated: true,
        preferredLanguage: "us_english",
      },
    },
  };

export const mockUnauthenticatedUserResponse: SupportApiResponse<undefined> = {
  statusCode: 302,
  status: 302,
  success: true,
  data: undefined,
};

export const mockGetCategoriesResponse: SupportApiResponse<GetCategoriesResponse> =
  {
    statusCode: 200,
    status: 200,
    success: true,
    data: {
      categories: [],
    },
  };

export const mockSupportPlanResponse: SupportApiResponse<GetSupportPlanResponse> =
  {
    status: 200,
    statusCode: 200,
    success: true,
    data: {
      currentPlan: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        billableItemSid: "BIb84abcf4eed7773c71c4365e21b32ce9" as any,
        friendlyName: "Personalized Support",
        displayName: "Personalized Support",
        level: {
          key: "personalized",
          tag: "org_level_pers",
        },
        overview:
          "You are currently on the Personalized support plan. This plan includes a toll-free phone number that you can call during business hours to speak with a member of our team, guaranteed response after-hours and on weekends for business-critical problems, accelerated guaranteed response time for other support requests, dedicated support engineer, and an escalation line to the duty manager",
        price: 5000,
        pricePercent: 0.08,
        description:
          "24x7 phone and web support with guaranteed response times, dedicated support engineer, and an escalation line to the duty manager",
        phoneNumbers: [
          {
            country: "Australia Toll-Free",
            number: "+61 1800 952932",
          },
          {
            country: "Brazil Toll-Free",
            number: "+55 0 800 591 2911",
          },
          {
            country: "Hong Kong Local",
            number: "+1 (855) 581-1581",
          },
          {
            country: "Israel Local",
            number: "+97223763590",
          },
          {
            country: "India Toll-Free",
            number: "0008000402555",
          },
          {
            country: "Japan Toll-Free",
            number: "+81 800 700 6233",
          },
          {
            country: "Mexico Toll-Free",
            number: "+52 800 283 2799",
          },
          {
            country: "Netherlands VoIP",
            number: "+31 85 208 3300",
          },
          {
            country: "Philipines Toll-Free",
            number: "+63 1800 1 550 0011",
          },
          {
            country: "Sweden Toll-Free",
            number: "+46 200 753 487",
          },
          {
            country: "Singapore Local",
            number: "+65 3129 2991",
          },
          {
            country: "UK Local",
            number: "+44 1908 410778",
          },
          {
            country: "UK Toll-Free",
            number: "+44 800 802 1272",
          },
          {
            country: "US Local",
            number: "+1 650 459 4357",
          },
          {
            country: "US Toll-Free",
            number: "+1 (855) 581-1581",
          },
        ],
        shortDisplayName: "Personalized",
        endDate: null,
        startDate: "2023-07-27",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        status: "activ" as any,
      },
    },
  };

export const mockSystemStatusResponse: SupportApiResponse<
  SystemStatusResponse[]
> = {
  success: true,
  status: 200,
  statusCode: 200,
  data: [
    {
      name: "ACCOUNT SECURITY",
      status: "operational",
    },
    {
      name: "CARRIER NETWORK",
      status: "under_maintenance",
    },
    {
      name: "DEVELOPER TOOLS",
      status: "operational",
    },
    {
      name: "ELASTIC SIP TRUNKING",
      status: "operational",
    },
    {
      name: "FLEX",
      status: "operational",
    },
    {
      name: "FRONTLINE",
      status: "operational",
    },
    {
      name: "INTERCONNECT",
      status: "operational",
    },
    {
      name: "INTERNET OF THINGS",
      status: "operational",
    },
    {
      name: "PHONE NUMBERS",
      status: "operational",
    },
    {
      name: "PROGRAMMABLE CHAT",
      status: "operational",
    },
    {
      name: "PROGRAMMABLE MESSAGING",
      status: "degraded_performance",
    },
    {
      name: "PROGRAMMABLE VIDEO",
      status: "operational",
    },
    {
      name: "PROGRAMMABLE VOICE",
      status: "operational",
    },
    {
      name: "PROXY",
      status: "operational",
    },
    {
      name: "SERVERLESS",
      status: "operational",
    },
    {
      name: "TWILIO LIVE",
      status: "operational",
    },
    {
      name: "TWILIO PLATFORM",
      status: "operational",
    },
  ],
};
